import { useEntity } from '@backstage/plugin-catalog-react';

export const useAccountId = (): string => {
  const { entity } = useEntity();
  return entity.metadata.annotations?.['amazonaws.com/account-id'] || '';
};
